import { DesiredPosition } from './DesiredPosition'
export default DesiredPosition
